exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".topHeader__kv[data-v-a7cc8192]{max-width:100%;vertical-align:middle}.topHeader__lead[data-v-a7cc8192]{padding:16px 20px;margin:0 auto;background:#ff3c28}.topHeader__text[data-v-a7cc8192]{max-width:400px;margin:0 auto;text-align:center;font-weight:700;font-size:min(4vw,18px);line-height:1.667;color:#fff;letter-spacing:-.0667em}.topHeader__mizuhiki[data-v-a7cc8192]{max-width:100%;vertical-align:middle;position:relative;z-index:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a7cc8192","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2021/topHeader.vue
// module id = HQ8m
// module chunks = 0